export interface NewsItem {
  id: string;
  title: string;
  date: string;
  tag: string;
}

export const newsList: NewsItem[] = [
  { id: "n01", title: "《星河彼岸》口碑持续走高，科幻迷热议人性与孤独主题", date: "2025-09-30", tag: "影视资讯" },
  { id: "n02", title: "《迷雾之城》大结局播出，开放式结尾引发全网讨论", date: "2025-09-29", tag: "剧集动态" },
  { id: "n03", title: "《美食奇遇记》第二季官宣，原班人马将踏上新旅程", date: "2025-09-28", tag: "综艺快报" },
  { id: "n04", title: "《暗夜追踪》收视破纪录，刑侦题材再掀追剧热潮", date: "2025-09-26", tag: "收视榜单" },
  { id: "n05", title: "蘑菇视频十月片单公布，多部高分新作集中上线", date: "2025-09-25", tag: "平台公告" },
  { id: "n06", title: "《无声证词》点映获好评，法庭悬疑题材展现新表达", date: "2025-09-23", tag: "影视资讯" },
  { id: "n07", title: "《探险家联盟》高原特辑上线，记录极限环境下的协作与坚持", date: "2025-09-21", tag: "综艺快报" },
  { id: "n08", title: "秋季剧集前瞻：古装、悬疑、都市多题材同台竞技", date: "2025-09-19", tag: "剧集动态" },
];